module.exports = __webpack_public_path__ + "static/media/ecommerce.03baf028.png";